import {
  JsonSerializedParameterValueContents,
  ParameterValueContents,
  parseJsonSerializedParameterValueContents,
} from "@hex/common";

import { logErrorMsg } from "./logging";

export function safeParseJsonSerializedParameterValueContents(
  valueString: JsonSerializedParameterValueContents | null,
): ParameterValueContents {
  if (valueString == null) {
    return null;
  }
  try {
    return parseJsonSerializedParameterValueContents(valueString);
  } catch (err) {
    logErrorMsg(err, "safeParseJsonSerializedParameterValueContents");
    return null;
  }
}
